<template>
  <div class="gallery">
    <!-- On keepsakes page, link to subs, not image -->
    <template v-if="page.ItemID != $store.state.keepsakesID">
      <div class="view" v-if="page.gallery && page.gallery.length > 1 && !page.alternate_layout">
        <span>
          <i class="fa fa-image"></i> View gallery
        </span>
      </div>
      <a :class="[index > 3 && !page.alternate_layout ? 'hide popup' : 'popup', page.gallery.length == 1 ? 'full' : '']" :href="image.image" :key="image._id" :title="image.caption" v-for="(image, index) in page.gallery">
        <imgix :alt="image.caption" :h="page.gallery.length == 1 ? 406 : 220" :src="image.image" :w="page.gallery.length == 1 ? 658 : 329" v-if="index < 4 || page.alternate_layout == true"/>
      </a>
    </template>
    <template v-else>
      <router-link :key="sub.itemID" :to="sub.url" class="thumb" v-for="sub in page.subs">
        <img :alt="sub.name" :src="sub.image">
        <span class="thumb-span">{{sub.name}}</span>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: "PageGallery",
  props: ["page"]
}
</script>

<style scoped>
</style>
